
export const email = state => state.registration.email;
export const emailStatus = state => state.registration.emailStatus;
export const getMobile = state => state.registration.mobile;
export const getMobileErrorCode = state => state.registration.mobileErrorCode;
export const mobileMessage = state => state.registration.mobileMessage;
export const mobileErrorCode = state => state.registration.mobileErrorCode;
export const emailMessage = state => state.registration.emailMessage;
export const emailErrorCode = state => state.registration.emailErrorCode;
export const getPromocode = state => state.registration.promocode;
export const getFullPromocode = state => state.registration.fullPromocode;
export const getMigrationParam = state => state.registration.migrationParam;
export const getPromocodeStatus = state => state.registration.promocodeStatus;
export const getPromocodeMessage = state => state.registration.promocodeMessage;
export const error = state => state.registration.error;
export const isFinish = state => state.registration.isFinish;
export const links = state => state.registration.links;
export const stateError = state => state.registration.stateError;

export const getUsername = state => state.registration.username;
export const getUsernameStatus = state => state.registration.usernameStatus;
export const getUsernameMessage = state => state.registration.usernameMessage;

export const getPassword = state => state.registration.password;
export const getPasswordStatus = state => state.registration.passwordStatus;
export const getPasswordError = state => state.registration.passwordErrorMessage;

export const getPasswordConfirm = state => state.registration.passwordConfirm;
export const getPasswordConfirmStatus = state => state.registration.passwordConfirmStatus;

export const getFirstName = state => state.registration.firstname;
export const getFirstNameStatus = state => state.registration.firstnameStatus;
export const getFirstNameError = state => state.registration.firstnameErrorMessage;

export const getSurname = state => state.registration.surname;
export const getSurnameStatus = state => state.registration.surnameStatus;
export const getSurnameError = state => state.registration.surnameErrorMessage;

export const getBirthDay = state => state.registration.day;
export const getBirthMonth = state => state.registration.month;
export const getBirthYear = state => state.registration.year;
export const getBirthdateStatus = state => state.registration.dateStatus;
export const getBirthdateErrorMessage = state => state.registration.dateErrorMessage;

export const getMailFrom = state => state.registration.mailFrom;

export const getreactivationMessage = state => state.registration.reactivationMessage;
export const getreactivationParam = state => state.registration.reactivationParam;
export const getreactivationStatus = state => state.registration.reactivationStatus;
export const getreactivationCode = state => state.registration.reactivationCode;

export const getErrorMessage = state => state.registration.error;
export const getValidationMessage = state => state.registration.validationMessage;
export const invalidPromocodeMessage = state => state.registration.invalidPromocodeMessage;
export const getCountry = state => state.registration.country;
export const getOtpValid = state => state.registration.otpValid;
export const getAgentId = state => state.registration.agentId;
export const isModalOpen = state => state.registration.modalOpen;
export const getRecoveryPasswordStatus = state => state.registration.recoveryPasswordStatus;
export const getIsLoadingRecoveryPassword = state => state.registration.isLoadingRecoveryPassword;
export const getRecoveryPasswordMessage = state => state.registration.recoveryPasswordMessage;
export const getIsFormValidating = state => state.registration.isFormValidating;
export const getIsLoadingPromocodeCheck = state => state.registration.isLoadingPromocodeCheck;
export const getIsLoadingMobileCheck = state => state.registration.isLoadingMobileCheck;
export const getIsLoadingUsernameCheck = state => state.registration.isLoadingUsernameCheck;
export const getIsLoadingPasswordCheck = state => state.registration.isLoadingPasswordCheck;
export const getIsLoadingFirstNameCheck = state => state.registration.isLoadingFirstNameCheck;
export const getIsLoadingSurnameCheck = state => state.registration.isLoadingSurnameCheck;
export const getIsLoadingDateOfBirthCheck = state => state.registration.isLoadingDateOfBirthCheck;
export const getTermsStatus = state => state.registration.termsStatus;
export const getDeleteDormantClientStatus = state => state.registration.deleteDormantClientStatus;
export const getIsLoadingDeleteDormantClient = state => state.registration.isLoadingDeleteDormantClient;
export const getDeleteDormantClientMessage = state => state.registration.deleteDormantClientMessage;
export const getDeleteDormantClientEnabled = state => state.registration.deleteDormantClientEnabled;
export const getMobileUserInfo = state => state.registration.mobileUserInfo;